import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { interval } from 'rxjs';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class idsProductList {
  id: number;
  pmscode: String;
  cdatetime:String;
}
@Component({
  selector: 'app-ws-log',
  templateUrl: './ws-log.component.html',
  styleUrls: ['./ws-log.component.css'],
    providers: [
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
  })

@Component({
  selector: 'app-ws-log',
  templateUrl: './ws-log.component.html',
  styleUrls: ['./ws-log.component.css']
})
export class WsLogComponent implements OnInit {

 constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe) {
 
   }
// 'cdate'
   displayedColumns: string[] = ['status','message','xmlinfo','cdatetime'];
    Userid: any = [];
      apiresult: any;
      hotellistproperty: any;
      dropdownDeptData: any
      isProgressing: Boolean = false;
      dropdownSettingsDept: IDropdownSettings = {};
      searchBarFilter: boolean = false;
      selectedDate: any = new Date();
      selectedTOODate: any = new Date();
      public PGF: any = 0;
      public PGT: any = 50;
      pageSize = 50;
      requestPayload: any;
      public Pmscodevalue: any;
      selectedDeptItems: any;
      searchText = "";
      errorMessage: string;
      errorMsgSubscription: boolean;
      displayContent: boolean;
      addBtnDisabledFunc: boolean = true;
      hotelSearchDataStatus: any;
      heartBeatData: any;
      productType: any;
      currentDateStore: any;
      storeHeartBeatValue: any;
      blinkOfflineHotel: boolean;
      filterProperty: any
      excelFunction: boolean = false;
      dataSource: MatTableDataSource<idsProductList>
      StorelstRestr: any;
      totalcount: any = 0;
      idsProductList: idsProductList[] = [];
      @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
      @ViewChild(MatSort, { static: true }) sort: MatSort;
      today = new Date();
   ngOnInit() {
   this.isProgressing = true;
    this.callIDSUsersProperties();
    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
   }
 
   callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getPropertiesWSLog()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          this.hotellistproperty = this.apiresult;
          this.dropdownDeptData = this.apiresult;
          console.log('Property 113 = ', data)
          this.isProgressing = false;
        });
  }
  GetParseonlyDateTime(d: any) {
      console.log('GetParseonlyDateTime call', d.substring(12))
      return (d.substring(12));
    }
  changePropertySearch() {
        // console.log('selectedDeptItems = ',this.selectedDeptItems)
        if (this.selectedDeptItems) {
          this.searchBarFilter = false
          this.searchText = '';
          if (this.selectedDeptItems.length > 0) {
            console.log('if condition')
            this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
            console.log('pms code value = ', this.Pmscodevalue)
            this.errorMsgSubscription = true
            this.errorMessage = "Please select property and load"
            this.displayContent = false
            this.addBtnDisabledFunc = false
            // For Online Status
            this.apiCallIdsService
              .readHotelSearch(this.Pmscodevalue)
              .subscribe((data) => {
                console.log('readHotelSearch =', data)
                this.hotelSearchDataStatus = data[0].recordstatus
                this.productType = data[0].producttype
              });
            this.apiCallIdsService
              .readHeartbeat(this.Pmscodevalue)
              .subscribe((data) => {
                console.log('readHeartbeat =', data[0])
                this.heartBeatData = data[0].heartBeat
    
                // For blinking the record
                const today = new Date()
                console.log('Today Date = ', today);
                this.currentDateStore = today.toLocaleTimeString('it-IT')
                console.log('Today Date = ', this.currentDateStore);
                this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
                var start = this.storeHeartBeatValue.split(":");
                var end = this.currentDateStore.split(":");
                var startDate = new Date(0, 0, 0, start[0], start[1], 0);
                var endDate = new Date(0, 0, 0, end[0], end[1], 0);
                var diff = endDate.getTime() - startDate.getTime();
                var hours = Math.floor(diff / 1000 / 60 / 60);
                diff -= hours * 1000 * 60 * 60;
                var minutes = Math.floor(diff / 1000 / 60);
                // console.log('minutes difference',minutes)
                console.log('minutes difference', hours + ":" + minutes)
                if ((hours + ":" + minutes) > "0:30") {
                  console.log('blinkOfflineHotel true')
                  this.blinkOfflineHotel = true
                } else {
                  console.log('blinkOfflineHotel false')
                  this.blinkOfflineHotel = false
                }
              });
            interval(2000 * 60).subscribe(() => {
              this.heartbeatFunction();
            });
          } else {
            console.log('Else condition zero')
            this.errorMsgSubscription = true
            this.errorMessage = "Please select property and load"
            this.displayContent = false
 /*            this.addBtnDisabledFunc = true
            this.excelFunction = false */
          }
        } else {
          console.log('Property Not Selected')
        }
      }
    readWSLogMethod() {
        this.searchBarFilter = false
        this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
        this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
        if (this.selectedTOODate < this.selectedDate) {
          this.isProgressing = false;
          this.toastr.error('From date should be less than To date.');
        }
        else {
          this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyyMMdd');
          this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
          this.isProgressing = true;

          this.apiCallIdsService.readWSLog(this.Pmscodevalue,this.selectedDate)
            .subscribe((res) => {
              this.StorelstRestr = res;
               this.StorelstRestr = Array.isArray(res) ? res : [];
        if (
  !this.StorelstRestr.length ||
  this.StorelstRestr[0] === undefined ||
  this.StorelstRestr[0].rowcount === undefined
) {
                this.toastr.error('No Data Found');
                this.totalcount = 0
                console.log(this.totalcount)
                this.errorMsgSubscription = true
                this.errorMessage = "No Data Found"
                this.displayContent = false
                this.excelFunction = false
                this.isProgressing = false;
    
              } else {
                this.idsProductList = res;
                console.log('response ==',this.StorelstRestr)
                this.totalcount = this.StorelstRestr[0].rowcount;
                console.log('totalcount ==',this.totalcount)
                this.errorMsgSubscription = false
                this.displayContent = true
                this.excelFunction = true
                this.filterProperty = this.idsProductList
                this.dataSource = new MatTableDataSource(this.idsProductList);
                this.dataSource.paginator = this.paginator;
                this.toastr.success('Data loaded Successfully');
                this.isProgressing = false;
              }
            });
        }
        
      } 
      pageEvent(e:any) {
          console.log('pageEvent = ', e)
          var pageIndex = e.pageIndex;
          pageIndex = pageIndex;
          console.log('pageIndex = ', pageIndex)
          this.pageSize = e.pageSize
          console.log('pageSize = ', this.pageSize)
          this.PGF = this.pageSize * pageIndex + 1;
          this.PGT = this.PGF + e.pageSize - 1;
          console.log("this.PGF", this.PGF)
          console.log("this.PGT", this.PGT)
      }

      heartbeatFunction() {
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat
          });
      }


}
